import { Space } from 'antd';
import styled from 'styled-components';
import { Caption01, BodyLong01, ProductiveHeading07 } from 'components/styles';

export const RadioContent = styled(Space).attrs({
  direction: 'vertical',
  size: 0,
})`
  p {
    ${BodyLong01};
    color: var(--gray-100);
    margin-bottom: 0;
  }
  small {
    ${Caption01};
    color: var(--gray-80);
  }
`;

export const Title = styled.p`
  ${ProductiveHeading07};
  margin-bottom: var(--spacing-03);
`;

export const ModalTriggerContainer = styled.div`
  margin-left: var(--spacing-06);
`;
